import {SurveysTypeSelectorProps} from "./types";
import {FormattedMessage} from "react-intl";
import RadioGroup from "@ui-components/RadioGroup";

export const SurveysTypeSelector = ({
  selectedServicesType,
  setSelectedServicesType,
}: SurveysTypeSelectorProps) => (
  <div className="p-6">
    <RadioGroup
      title={
        <FormattedMessage id="services_type" defaultMessage="Tipologia di configurazioni" />
      }
      description={undefined}
      options={[
        {value: "design", name: <FormattedMessage id="design_services_tab_title" defaultMessage="Progettazione intervento" />},
        {value: "quotation", name: <FormattedMessage id="quotation_services_tab_title" defaultMessage="Definizione intervento" />},
        // {value: "service", name: <FormattedMessage id="service_services_tab_title" defaultMessage="Servizi" />},  // TODO uncomment this when services of type "service" are going to be public
      ]}
      onChange={setSelectedServicesType}
      currentValue={selectedServicesType}
      horizontal={false}
    />
  </div>
)